var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowStamp),expression:"isShowStamp"}],staticClass:"coupon-stamp-component"},[_c('div',{staticClass:"inner"},[_c('i',[_vm._v(_vm._s(_vm.stampText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }